<td *ngFor="let j of [].constructor(tdAmount); let idx = index">
  <div [ngClass]="blankSpaceIndices.includes(idx) ? ' blank-space' : 'td-empty-state'"></div>
</td>
